import React from 'react';
const LockIcon = ({ fill, width, height, opacity, ...rest }) => (
    <svg width={width} height={height} viewBox="0 0 16 21" {...rest}>
        <defs>
            <path
                id="lockIcon"
                d="M15.5 21h9v-2c0-2.8-2-5-4.5-5s-4.5 2.2-4.5 5v2zm11 0a1 1 0 0 1 1 1v6a4 4 0 0 1-4 4h-7a4 4 0 0 1-4-4v-6a1 1 0 0 1 1-1v-2c0-3.9 2.9-7 6.5-7s6.5 3.1 6.5 7v2zM20 29a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
            />
        </defs>
        <use fill={fill} opacity={opacity} xlinkHref="#lockIcon" fillRule="evenodd" transform="translate(-12 -12)" />
    </svg>
);

export default LockIcon;
